import { render, staticRenderFns } from "./RegionServiceFees.vue?vue&type=template&id=40ad2790&scoped=true"
import script from "./RegionServiceFees.vue?vue&type=script&lang=js"
export * from "./RegionServiceFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ad2790",
  null
  
)

export default component.exports